import React from 'react';
import PropTypes from 'prop-types';
import { useTitle } from '../../../Title/containers/TitleDataStore';
import { Translate } from '@above-the-treeline/localization';
import ListTitleIsOnBullet from './ListTitleIsOnBullet';
import './listAssign.less';

ListsTitleIsOnSection.propTypes = {
	getCommunity: PropTypes.func,
};

function ListsTitleIsOnSection({ getCommunity }) {
	const titleDataStore = useTitle();
	const { lists } = titleDataStore.state.collaborativeLists;

	const getTitleBullets = () =>
		lists.map((list, index) => {
			const community = getCommunity(list);
			return (
				<ListTitleIsOnBullet
					key={index}
					communityName={community.name}
					list={list}
				/>
			);
		});

	const getNoListsMessage = () => (
		<p className="no-lists-message">
			<Translate id="not_included_on_any_lists" />
		</p>
	);

	return (
		<div className="current-lists">
			{lists && lists.length ? getTitleBullets() : getNoListsMessage()}
		</div>
	);
}

export default ListsTitleIsOnSection;
